import { IDistriwinFeedConsumption, IDistriwinFeedConsumptionDto } from 'shared/api/api';
import { Syncable } from 'shared/state/models/syncable';

export const GET_DISTRIWIN_FEED_CONSUMPTION_DTOS = 'GET_DISTRIWIN_FEED_CONSUMPTION_DTOS';

export interface DistriwinFeedConsumptionState extends Syncable<IDistriwinFeedConsumption> {
	dtoEntities: IDistriwinFeedConsumptionDto[];
	pending: boolean;
}
